import React from 'react';
import addContext from './addContext';

export default function addD2Context(Component) {
    return addContext(Component, { d2: React.PropTypes.object });
}


//////////////////
// WEBPACK FOOTER
// ./~/d2-ui/lib/component-helpers/addD2Context.js
// module id = 38
// module chunks = 0